import { apiCall } from "../../service/api-service.js";

// Asset Files Logs Listing
export const getFileApi = async (params) => 
  apiCall("get", `asset/attachment/${params}`);

// Files Save
export const saveFileApi = async (id, body) => 
  apiCall("post", `asset/attachment/${id}`, body);

// Asset profile Page
export const getProfileViewApi = async (params) => 
  apiCall("get", `asset/profile/${params}`);

// Asset View Page
export const getAssetViewApi = async (params) => 
  apiCall("get", `asset/view/${params}`);

// Asset Gate Logs Listing
export const getGateApi = async (id, params) => 
  apiCall("get", `asset/transaction/${id}`, null, { params });

// Asset Assigned History Listing
export const getHistoryApi = async (id, params) => 
  apiCall("get", `asset/assign/${id}`, null, { params });

// Asset Data Entries Listing
export const getDataApi = async (id, params) => 
  apiCall("get", `asset/date_entry/${id}`, null, { params });

// Asset Validations Listing
export const getValidationsApi = async (id, params) => 
  apiCall("get", `asset/validation/${id}`, null, { params });

// Asset Edited History Listing
export const getEditedHistoryApi = async (id, params) => 
  apiCall("get", `asset/activity/${id}`, null, { params });

// Reminder View Page
export const getReminderViewApi = async (params) => 
  apiCall("get", `reminder/${params}`);
